export default function httpUrlRule(required: boolean = false) {
  return {
    required,
    validator: (_: any, value: string) => {
      if (!value) {
        if (required) 
          return Promise.reject(new Error("This field is required!"));
        else 
          return Promise.resolve();
      }

      if (!value.startsWith("https://")) 
        return Promise.reject(
          new Error("Please enter a valid URL starting with “https://”.")
        );
      
      return Promise.resolve();
    },
  };
}